export const NAVBAR_TYPE_LIGHT = 'light';
